import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import api from '../middleware/api'
import analytics from '../middleware/analytics'
import timing from '../middleware/timing'
import macmillan from '../middleware/macmillan'
import loggly from '../middleware/loggly'

import { createLogger } from 'redux-logger'
import rootReducer from '../reducers'
import { responsiveStoreEnhancer } from 'redux-responsive'

export default function configure (initialState) {
  const create = window.devToolsExtension && process.env.NODE_ENV !== 'production'
    ? window.devToolsExtension()(createStore)
    : createStore

  const middleware = [
    thunk,
    macmillan,
    api,
    analytics,
    timing,
    loggly
  ]

  if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger({
      collapsed: true
    }))
  }

  const createStoreWithMiddleware = compose(responsiveStoreEnhancer, applyMiddleware(...middleware))(create)
  const store = createStoreWithMiddleware(rootReducer, initialState)

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers')
      store.replaceReducer(nextReducer)
    })
  }

  return store
}
